import { fetchStationDetail, receiveStationDetail, changeTimetableCollapsed } from '../actions'
import { connect } from 'react-redux'
import { showAlert } from '../utils/Alert'
import StationDetail from '../components/station/StationDetail'

const mapStateToProps = (state, _props) => {
  const {
    station,
    streetViewUrl,
    hasIncidents,
    timetables,
  } = state.stationReducer
  const { themeName } = state.themeReducer

  return {
    station,
    streetViewUrl,
    hasIncidents,
    timetables,
    themeName,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchStationDetail: async (stationId) => {
      try {
        const payload = await fetchStationDetail(stationId)
        dispatch(receiveStationDetail(payload))
      } catch (error) {
        showAlert("駅情報が取得できませんでした")
      }
    },
    changeTimetableCollapsed: (timetableIndex, isCollapsed) => {
      dispatch(changeTimetableCollapsed(timetableIndex, isCollapsed))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StationDetail)